import SystemApiBase from "../base/SystemApiBase";

import {
  LogAppUsageRequestBody,
  LogAppUsageRequestBodySchema,
} from "@/schemas/api/analytics";
import type { OkResponse } from "@/schemas/api/ok";

/**
 * Service responsible for tracking and submitting analytics data.
 * Extends the SystemApiBase class with analytics-specific functionality.
 */
export class AnalyticsService extends SystemApiBase {
  public constructor() {
    super("/analytics");
  }

  /**
   * Logs app usage events to the analytics service
   * @param body - Request body containing one or more analytics events
   * @returns Promise resolving to an OkResponse when successful
   * @throws Error if request body validation fails
   */
  public logAppUsage(body: LogAppUsageRequestBody): Promise<OkResponse> {
    const parseResult = LogAppUsageRequestBodySchema.safeParse(body);
    if (!parseResult.success) {
      throw new Error(
        `Invalid analytics request: ${parseResult.error.message}`,
      );
    }

    // invalid LogAppUsageEventBody inside LogAppUsageRequestBody would not be proceeded on the server side
    return this.post<OkResponse>("/", body);
  }
}

export default AnalyticsService;
